import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetLoanApi,
  GetLoanLogApi,
  GetLoanLogByBranchApi,
  GetLoansByBranchApi,
} from "../../ApiRequests";

const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId = "", role = 1 } = userData;

export const fetchLoans = createAsyncThunk("fetch/Loans", async () => {
  try {
    const response =
      role === 2
        ? await GetLoansByBranchApi(branchId)
        : await GetLoanApi();
    if (response?.data?.success) {
      return response.data.data.payload;
    }
  } catch (error) {
    console.log(error);
  }
  return [];
});

export const fetchLoanLog = createAsyncThunk("fetch/LoanLog", async () => {
  try {
    const response =
      role === 2
        ? await GetLoanLogByBranchApi(branchId)
        : await GetLoanLogApi();
    if (response?.data?.success) {
      return response.data.data.payload;
    }
  } catch (error) {
    console.log(error);
  }
  return [];
});

const LoanSlice = createSlice({
  name: "loans",
  initialState: {
    loading: false,
    data: [],
    log: [],
    logLoading: false,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLoans.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchLoans.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload || [];
      state.isError = false;
    });
    builder.addCase(fetchLoans.rejected, (state) => {
      state.loading = false;
      state.isError = true;
    });
    builder.addCase(fetchLoanLog.pending, (state) => {
      state.logLoading = true;
    });
    builder.addCase(fetchLoanLog.fulfilled, (state, action) => {
      state.logLoading = false;
      state.log = action.payload || [];
    });
    builder.addCase(fetchLoanLog.rejected, (state) => {
      state.logLoading = false;
    });
  },
});

export default LoanSlice.reducer;
